export const PAYMENT_FEATURE_LAZY = 'paymentFeature';
export const PAYMENT_UI_LAZY = 'paymentUi';
